/* @flow */

import * as React from 'react';
import ReactTooltip from 'react-tooltip';
import {MinimizeIcon} from '../../icon';
import './minimize-button.css';

type Props = {
    size?: number,
    tooltip?: string,
    getRef?: (?HTMLButtonElement) => void,
    onClick: (e: SyntheticEvent<>) => void,
    isMaximizeButton?: boolean,
};

export class MinimizeButton extends React.PureComponent<Props> {
    static defaultProps = {
        size: 14,
    };

    componentDidMount() {
        ReactTooltip.rebuild();
    }

    componentWillUnmount() {
        ReactTooltip.hide();
    }

    render() {
        let tooltip = this.props.isMaximizeButton ? 'Enlarge' : 'Minimize';
        if (this.props.tooltip) {
            tooltip = this.props.tooltip;
        }

        return (
            <button
                data-tip={tooltip}
                onClick={this.props.onClick}
                ref={this.props.getRef}
                styleName={
                    this.props.isMaximizeButton ? 'container--maximize' : 'container--minimize'
                }
            >
                <MinimizeIcon size={this.props.size} />
            </button>
        );
    }
}
